import React from 'react';

export const Badge = (): JSX.Element => {
  return (
    <svg
      width="79"
      height="24"
      viewBox="0 0 79 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="78.5878" height="24" rx="12" fill="#87C221" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0526 14.5801L16.2333 16.8444L20.458 14.5801L22.4273 15.6314L16.2333 18.947L10.1053 15.6314L12.0526 14.5801Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0526 11.0078L16.2333 13.0612L20.458 11.0078L22.4273 11.9661L16.2333 14.9777L10.1053 11.9661L12.0526 11.0078Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2334 5.05273L10.1054 8.2231L16.2334 11.4046L22.4274 8.2231L16.2334 5.05273Z"
        fill="white"
      />
      <path
        d="M35.3689 9.33789L42.3773 16.3375"
        stroke="white"
        strokeWidth="0.575626"
        strokeLinecap="round"
      />
      <path
        d="M35.3689 16.3379L42.3772 9.33829"
        stroke="white"
        strokeWidth="0.575626"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.3228 8.96766C68.3228 8.96766 68.1664 7.91791 67.6866 7.45549C67.0784 6.84887 66.3963 6.84599 66.0835 6.81045C63.8446 6.65625 60.486 6.65625 60.486 6.65625H60.4789C60.4789 6.65625 57.1205 6.65625 54.8814 6.81045C54.5687 6.84599 53.8869 6.84887 53.2784 7.45549C52.7986 7.91791 52.6425 8.96766 52.6425 8.96766C52.6425 8.96766 52.4825 10.2004 52.4825 11.4331V12.589C52.4825 13.8215 52.6425 15.0542 52.6425 15.0542C52.6425 15.0542 52.7986 16.104 53.2784 16.5664C53.8869 17.1732 54.6864 17.1537 55.0425 17.2174C56.3227 17.3343 60.4825 17.3705 60.4825 17.3705C60.4825 17.3705 63.8446 17.3656 66.0835 17.2116C66.3963 17.1761 67.0784 17.1732 67.6866 16.5664C68.1664 16.104 68.3228 15.0542 68.3228 15.0542C68.3228 15.0542 68.4825 13.8215 68.4825 12.589V11.4331C68.4825 10.2004 68.3228 8.96766 68.3228 8.96766ZM58.8307 13.9892L58.83 9.70918L63.1532 11.8566L58.8307 13.9892Z"
        fill="white"
      />
    </svg>
  );
};
